export default __webpack_public_path__ + "static/media/girlSitting.0eccb8c1.svg";